//$('.jj_inner_artists .banner1_menu .m-mega-banner__inner').appendTo($('.jj_inner_artists li.m-sub-menu__item.m-sub-menu__item--level-1').eq(0));
//$('.jj_inner_artists .banner2_menu .m-mega-banner__inner').appendTo($('.jj_inner_artists li.m-sub-menu__item.m-sub-menu__item--level-1').eq(1));

/*document.addEventListener('DOMContentLoaded', () => {
  const readMoreBtn = document.querySelector('.read-more-btn');
  const shortDesc = document.querySelector('.short-description');
  const fullDesc = document.querySelector('.full-description');

  if (readMoreBtn) {
    readMoreBtn.addEventListener('click', () => {
      if (fullDesc.style.display === 'none') {
        fullDesc.style.display = 'block';
        shortDesc.style.display = 'none';
        readMoreBtn.textContent = 'Read Less';
      } else {
        fullDesc.style.display = 'none';
        shortDesc.style.display = 'block';
        readMoreBtn.textContent = 'Read More';
      }
    });
  }
  
});*/

  

document.addEventListener('DOMContentLoaded', () => {
  const readMoreBtns = document.querySelectorAll('.read-more-btn'); // Select all buttons
  readMoreBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      const container = btn.closest('.collection-description');
      if (!container) {
        console.error('No description-container found for this button.');
        return; // Skip to the next button
      }

      const shortDesc = container.querySelector('.short-description');
      const fullDesc = container.querySelector('.full-description');

      if (!shortDesc || !fullDesc) {
        console.error('Short or full description missing in the container.');
        return; // Skip this iteration
      }

      if (fullDesc.style.display === 'none' || fullDesc.style.display === '') {
        fullDesc.style.display = 'block';
        shortDesc.style.display = 'none';
        btn.textContent = 'Read Less';
      } else {
        fullDesc.style.display = 'none';
        shortDesc.style.display = 'block';
        btn.textContent = 'Read More';
      }
    });
  });
});

// Select all <li> elements and section elements
const listItems = document.querySelectorAll('.artists_links li');
const sections = document.querySelectorAll('.catalogue_our_story');
const sectionsfirst = document.querySelectorAll('.custom_catalogue_artist_image');

// Add event listeners to each <li>
listItems.forEach((item, index) => {
  item.addEventListener('click', () => {
    // Get the section corresponding to the clicked <li> index
    
    if(index == 0)
    {
      console.log("index"+index);
      const targetSectionFirst = sectionsfirst[1];
      // Scroll to the respective section
      if (targetSectionFirst) {
        targetSectionFirst.scrollIntoView({ behavior: 'smooth' });
      }
    }else{
      const targetSection = sections[index];
      // Scroll to the respective section
      if (targetSection) {
        targetSection.scrollIntoView({ behavior: 'smooth' });
      }
    }
    
    
  });
});


//$('.faqs-section').wrapAll("<div class='faqs-section-wrapper'></div>");
$('.faqs .faqs-section').eq(0).addClass('first_faqc');
/*$(document).ready(function() {
    // Select all items
    var items = $('.faqs_section .m-faqs-section__content .m-faqs-section__block.m-faqs-section__block-accordion');
    var totalItems = items.length;

    // Calculate the number of items per column
    var half = Math.ceil(totalItems / 2);

    // Create new divs for the columns
    var column1 = $('<div class="column-faq left_faq"></div>');
    var column2 = $('<div class="column-faq right_faq"></div>');

    // Append items to the respective columns
    items.each(function(index) {
        if (index < half) {
            column1.append($(this));
        } else {
            column2.append($(this));
        }
    });

    // Clear the original container and append the columns
    $('.faqs_section .m-faqs-section__content').empty().append(column1, column2);
    //$("<div class='m-faqs-section__content second_div_faqs'></div>").insertAfter($('.m-faqs-section__content'));
    //$('.second_div_faqs').empty().append(column2);
});*/

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.toggle-btn-seo').forEach(btn => {
    btn.addEventListener('click', () => {
      const content = btn.previousElementSibling;
      const icon = btn.querySelector('.icon-seo');
      content.classList.toggle('expanded');
      if (content.classList.contains('expanded')) {
        btn.innerHTML = '<span class="icon-seo">-</span> ';
      } else {
        btn.innerHTML = '<span class="icon-seo">+</span> ';
      }
    });
  });
});



/*document.addEventListener('DOMContentLoaded', function () {
    // Check if we are on a collection page
    if (window.location.pathname.includes('/collections/') && !window.location.search.includes('sort_by=')) {
        const currentUrl = window.location.href.split('?')[0]; // Get base URL without query params
        const newUrl = `${currentUrl}?sort_by=price-ascending`; // Append the sort parameter
        window.location.href = newUrl; // Redirect to the new URL
    }
});*/

/*let mySwiper;

function initSwiper() {
    // Destroy existing Swiper instance if it exists
    if (mySwiper) {
        mySwiper.destroy(true, true);
    }

    // Initialize a new Swiper instance
    mySwiper = new Swiper('.margin_bottom_remove .swiper-wrapper', {
        slidesPerView: 2
    });
}

// Run the slider logic on page load
document.addEventListener('DOMContentLoaded', () => {
  initSwiper();
});*/


if($('.full_width_catalogue_image_section').length > 0)
{
  $('body').addClass('strangers-catalogue');
}

$('<h4 class="m-mega-banner__title"><a href="/pages/artists" class="m-mega-banner__button m-button m-button--link"><svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 12H20M20 12L14 6M20 12L14 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg> View All Artists</a></h4>').appendTo($('.jj_inner_artists li.m-sub-menu__item.m-sub-menu__item--level-1').eq(0));
$('<h4 class="m-mega-banner__title"><a href="/pages/exhibitions" class="m-mega-banner__button m-button m-button--link"><svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 12H20M20 12L14 6M20 12L14 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg> View All Events & Fairs</a></h4>').appendTo($('.jj_inner_events-fairs li.m-sub-menu__item.m-sub-menu__item--level-1').eq(0));